// import node module libraries
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
// import custom components

// import services

const EditInfoPersonnelles = (props) => {
	const { next, initialValues } = props;

	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [formValues, setFormValues] = useState({
		...initialValues,
		photo: initialValues.photo
			? {
					file: initialValues.photo.file,
					fileURL: initialValues.photo.fileURL
			  }
			: ''
	});
	const [selectedGenre, setSelectedGenre] = useState('');

	const GENRE_CHOICES = [
		{ value: 'm', label: 'Masculin' },
		{ value: 'f', label: 'Feminin' }
	];

	const handleChange = (field, value, feedbackMessage) => {
		// Update feedbackMessages
		setFeedbackMessages((prevMessages) => ({
			...prevMessages,
			[field]: feedbackMessage
		}));

		// Update formValues
		const newFormValues = {
			...formValues,
			[field]: value
		};
		setFormValues(newFormValues);

		// Call the onChange function passed in props with all the values
		props.onChange(newFormValues);
	};

	useEffect(() => {
		setFormValues(initialValues);
		setSelectedGenre(initialValues.genre);
	}, [initialValues]);

	return (
		<div>
			{/* Card */}
			<Card className="mb-3 ">
				<Card.Header className="border-bottom px-4 py-3">
					<h4 className="mb-0">Informations Personnelles</h4>
				</Card.Header>
				{/* Card body */}
				<Card.Body>
					{/* Nom et prenom  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="nom">
									Nom <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="nom"
									type="text"
									placeholder="Saisir le nom de l'élève"
									id="nom"
									required
									isInvalid={!!feedbackMessages['nom']}
									value={formValues.nom || ''} // Utiliser formValues.nom comme valeur par défaut
									onChange={(e) => {
										const value = e.target.value;
										const feedbackMessage = value ? '' : 'Le nom est requis.';
										handleChange('nom', value, feedbackMessage);
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['nom']}
								</Form.Control.Feedback>
							</Col>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="prenom">
									Prénom <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="prenom"
									type="text"
									placeholder="Saisir le prénom de l'élève"
									id="prenom"
									required
									isInvalid={!!feedbackMessages['prenom']}
									value={formValues.prenom || ''}
									onChange={(e) => {
										const value = e.target.value;
										const feedbackMessage = value
											? ''
											: 'Le prénom est requis.';
										handleChange('prenom', value, feedbackMessage);
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['prenom']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>

					{/* Date et Lieu de naissance */}
					<Form.Group>
						<Row>
							<Col lg={4} md={12} sm={12} className="mb-3">
								<Form.Label>
									Date de Naissance <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="date_naissance"
									type="date"
									placeholder="Selectionner la date de naissance"
									id="date_naissance"
									required
									isInvalid={!!feedbackMessages['date_naissance']}
									value={formValues.date_naissance || ''}
									onChange={(e) => {
										const value = e.target.value;
										const feedbackMessage = value
											? ''
											: 'La date de naissance est requise.';
										handleChange('date_naissance', value, feedbackMessage);
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['date_naissance']}
								</Form.Control.Feedback>
							</Col>

							<Col lg={4} md={12} sm={12} className="mb-3">
								<Form.Label htmlFor="lieu_naissance">
									Lieu de naissance <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="lieu_naissance"
									type="text"
									placeholder="Saisir le lieu de naissance"
									id="lieu_naissance"
									required
									isInvalid={!!feedbackMessages['lieu_naissance']}
									value={formValues.lieu_naissance || ''}
									onChange={(e) => {
										const value = e.target.value;
										const feedbackMessage = value
											? ''
											: 'Le lieu de naissance est requis.';
										handleChange('lieu_naissance', value, feedbackMessage);
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['lieu_naissance']}
								</Form.Control.Feedback>
							</Col>
							<Col lg={4} md={12} sm={12} className="mb-3">
								<Form.Label htmlFor="genre">
									Genre <span className="text-danger">*</span>
								</Form.Label>
								<Form.Select
									name="genre"
									required
									isInvalid={!!feedbackMessages['genre']}
									value={selectedGenre}
									onChange={(e) => {
										const value = e.target.value;
										const feedbackMessage = value
											? ''
											: "Le genre de l'élève est requis.";
										handleChange('genre', value, feedbackMessage);
										setSelectedGenre(value);
									}}
								>
									{GENRE_CHOICES.map((choice, index) => (
										<option key={index} value={choice.value}>
											{choice.label}
										</option>
									))}
								</Form.Select>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['genre']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>

					{/* Langue maternelle  */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="langue_maternelle">
							Langue maternelle <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="langue_maternelle"
							type="text"
							placeholder="Saisir la langue maternelle de l'élève"
							id="langue_maternelle"
							required
							isInvalid={!!feedbackMessages['langue_maternelle']}
							value={formValues.langue_maternelle || ''}
							onChange={(e) => {
								const value = e.target.value;
								const feedbackMessage = value
									? ''
									: "La langue maternelle de l'élève est requise.";
								handleChange('langue_maternelle', value, feedbackMessage);
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['langue_maternelle']}
						</Form.Control.Feedback>
					</Form.Group>

					{/* Photo */}
					<Form.Group className="mb-3">
						<Form.Label htmlFor="photo">Photo de profil</Form.Label>
						<Form.Control
							name="photo"
							type="file"
							placeholder="Selectionner la photo de profil de l'élève"
							id="photo"
							accept="image/*"
							isInvalid={!!feedbackMessages['photo']}
							onChange={(e) => {
								const file = e.target.files[0];
								const isValidFile = file && file.type.startsWith('image/');
								const feedbackMessage = isValidFile
									? ''
									: "Le fichier sélectionné n'est pas une image.";

								// Update feedbackMessages
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									photo: feedbackMessage
								}));

								if (isValidFile) {
									// Convert the file to a blob URL and pass it to the parent component
									const fileURL = URL.createObjectURL(file);
									// Update form values with both the file and the fileURL
									handleChange('photo', { file, fileURL }, feedbackMessage);
								}
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['photo']}
						</Form.Control.Feedback>
					</Form.Group>
				</Card.Body>
			</Card>
			{/* Button */}
			<Button variant="primary" onClick={next}>
				Suivant
			</Button>
		</div>
	);
};
export default EditInfoPersonnelles;
